import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="min-h-full bg-chatBg flex items-center justify-center p-8">
      <div className="text-center">
        <h1 className="text-navy text-3xl font-extrabold">404</h1>
        <p className="text-gray-600 mt-2">That page doesn&apos;t exist.</p>
        <Link to="/" className="inline-block mt-4 text-navy font-bold hover:underline">
          Back to home
        </Link>
      </div>
    </div>
  )
}
